import React from "react";

import { useRecoilValueLoadable } from "recoil";
import { aspectType, asyncGetAspectList } from "lib/store/dashboard";

import { Skeleton } from "components/atom/Skeleton";
import { SentimentStackedBarChart } from "components/atom/SentimentStackedBarChart";

import "./DashboardSentimentSummary.scss";

const useTempHook = () => {
  let returnVal = [];
  const { state, contents } = useRecoilValueLoadable(asyncGetAspectList);
  if (state === "hasValue") {
    returnVal = contents;
  }

  return { state, contents: returnVal };
};

export const DashboardSentimentSummary: React.FC = () => {
  const { state, contents } = useTempHook();
  console.log(state, contents);
  return (
    <>
      {state === "hasValue" ? (
        <div className={"scroll-wrapper"}>
          {contents.map(
            ({ aspect, positive, negative, neutral }: aspectType) => (
              <SentimentStackedBarChart
                key={`${aspect}-chart`}
                aspect={aspect}
                positive={positive}
                negative={negative}
                neutral={neutral}
              />
            )
          )}
        </div>
      ) : (
        <div className={"skeleton-wrapper"}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      )}
    </>
  );
};
